export default "/images/ico-galka.svg?c916da472e74bac5f97a4c2902af18c3";